import { Trash2, Pencil } from "lucide-react";
import { API } from "@/lib/api";

export function ChartsTab({
  charts, restoring, onRestore, rerenderingAll, onRerenderAll, editing, setEditing, rerendering, onRerender, onEdit, onDelete,
}) {
  return (
    <div data-testid="admin-charts-list" className="space-y-2">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4 border border-[#FFD700]/25 bg-[#FFD700]/5 p-5">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FFD700]">Library Restore Pack</p>
          <p className="mt-1 text-xs text-[#A1A1A6]">
            Full chart library backup code-உடன் உள்ளது — missing charts ஒரே click-இல் மீட்கலாம் (duplicates வராது)
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <button
            data-testid="rerender-all-btn"
            onClick={onRerenderAll}
            disabled={rerenderingAll}
            className="rounded-full border border-[#FFD700]/60 px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] text-[#FFD700] transition-colors duration-300 hover:bg-[#FFD700] hover:text-black disabled:opacity-50"
          >
            {rerenderingAll ? "Re-rendering…" : "Re-render all"}
          </button>
          <button
            data-testid="restore-library-btn"
            onClick={onRestore}
            disabled={restoring}
            className="rounded-full bg-[#FFD700] px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-105 disabled:opacity-50"
          >
            {restoring ? "Restoring…" : "Restore full library"}
          </button>
        </div>
      </div>
      {editing && (
        <div data-testid="chart-edit-panel" className="mb-8 space-y-4 border border-[#FFD700]/40 bg-black/40 p-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FFD700]">
            Edit chart — numbers மாத்தி save பண்ணா image தானா re-render ஆகும்
          </p>
          <input
            data-testid="chart-edit-title"
            value={editing.title}
            onChange={(e) => setEditing({ ...editing, title: e.target.value })}
            className="w-full border border-white/10 bg-black px-4 py-3 text-sm font-semibold text-white outline-none focus:border-[#FFD700]/60"
          />
          <textarea
            data-testid="chart-edit-text"
            value={editing.text}
            onChange={(e) => setEditing({ ...editing, text: e.target.value })}
            rows={16}
            wrap="off"
            className="w-full overflow-x-auto whitespace-pre border border-white/10 bg-black px-4 py-3 font-mono text-xs leading-relaxed text-[#FDFBF7] outline-none focus:border-[#FFD700]/60"
          />
          <div className="flex gap-3">
            <button
              data-testid="chart-edit-save"
              onClick={onRerender}
              disabled={rerendering}
              className="rounded-full bg-[#FFD700] px-8 py-3 text-xs font-bold uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-105 disabled:opacity-50"
            >
              {rerendering ? "Re-rendering..." : "Save & re-render"}
            </button>
            <button
              data-testid="chart-edit-cancel"
              onClick={() => setEditing(null)}
              className="rounded-full border border-white/15 px-8 py-3 text-xs font-bold uppercase tracking-[0.15em] text-[#A1A1A6] transition-colors duration-300 hover:text-white"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {charts.length === 0 && (
        <p className="border border-dashed border-white/15 py-16 text-center font-mono text-xs uppercase tracking-[0.25em] text-[#666666]">
          No charts yet
        </p>
      )}
      {charts.map((chart) => (
        <div
          key={chart.id}
          data-testid={`admin-chart-row-${chart.id}`}
          className="flex items-center gap-4 border border-white/10 bg-black/40 p-3"
        >
          <img
            src={`${API}/files/${chart.url.replace("/api/files/", "")}`}
            alt=""
            className="h-14 w-11 rounded object-cover"
          />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold">{chart.title}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#666666]">
              {chart.variant_label} · {chart.category_name}
            </p>
          </div>
          {chart.source_text_id && (
            <button
              data-testid={`admin-chart-edit-${chart.id}`}
              onClick={() => onEdit(chart)}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-[#A1A1A6] transition-colors duration-300 hover:border-[#FFD700]/60 hover:text-[#FFD700]"
            >
              <Pencil className="h-4 w-4" />
            </button>
          )}
          <button
            data-testid={`admin-chart-delete-${chart.id}`}
            onClick={() => onDelete(chart.id)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-[#A1A1A6] transition-colors duration-300 hover:border-[#E63946]/60 hover:text-[#E63946]"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
